module.exports = __webpack_public_path__ + "static/media/IAVP Logo for VPMA.62120ee0.png";